.IamRequestPermissionsModal {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 10000000;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    font-size: 1rem;
    background: rgba(#2d3e50, 0.5);

    &__content {
        background: #fff;
        padding: 40px;
    }

    &__footer {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 30px;
    }

    &--closed {
        display: none;
    }

    &__accept,
    &__decline {
        cursor: pointer;
        background: #2cb698;
        color: #fff;
        border: 0;
        font: inherit;
        white-space: nowrap;
        height: 2.8rem;
        line-height: 2.8rem;
        padding: 0 2rem;
        margin: 0 10px;
        border-radius: 1.4rem;
    }

    &__decline {
        background: #eee;
        color: #333;
    }

    &__list {
        font-size: 0.85em;
        font-weight: bold;
        background: #f2f2f2;
        margin: 20px -40px;
        padding: 10px 40px;
        list-style: none;

        > li {
            font-size: 1em;
        }
    }
}
